export const LANG_TEST_REQUEST = 'LANG_TEST_REQUEST';
export const LANG_TEST_RECEIVE = 'LANG_TEST_RECEIVE';
export const LANG_TEST_ERROR = 'LANG_TEST_ERROR';



// WEBPACK FOOTER //
// ./src/store/languageTest/actionTypes.js